import { number, oneOfType, string } from 'prop-types';

const PT_STARS = {
  className: string,
  value: oneOfType([string, number]),
};

const DF_STARS = {
  className: '',
  value: 0,
};

export { PT_STARS, DF_STARS };
